export default {
    // vue-ls options
    storageOptions: {
        namespace: 'zx_gs_', // key prefix
        name: 'ls', // name variable Vue.[ls] or this.[$ls],
        storage: 'local', // storage name session, local, memory
    }
}